<template>
  <ul class="list--none">
    <p class="white--text text--lighten-4 body-2">
      {{ title }}
    </p>
    <li class="ma-1" v-for="(tag, index) in items" :key="`q1-${index}`">
      <span class="pr-2">{{ tag.title }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: "ResultsList",
  props: {
    title: String,
    items: Array,
    innerClass: String,
  },
};
</script>
